import { JsonConverter, JsonDiscriminatorValue, JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapCultureTo } from "../base-types";
import DataType from "../contracts/base/data-type";
import { MemberDefinitionType } from "../contracts/base/member-definition-type";
import type { RelationCardinalityType } from "../contracts/base/relation-cardinality";
import type { RelationRoleType } from "../contracts/base/relation-role";
import Link from "../link";
import {
    ConditionalValidationResource,
    ConditionalValidationResourceConverter,
} from "./conditional-validation-resource";
import { MemberDefinitionResource } from "./member-definition-resource";
@JsonObject()
@JsonDiscriminatorValue(DataType.Relation)
export class RelationDefinitionResource extends MemberDefinitionResource {
    @JsonProperty("role")
    role: RelationRoleType;

    @JsonProperty("cardinality")
    cardinality: RelationCardinalityType;

    @JsonProperty("child_is_mandatory")
    childIsMandatory: boolean;

    @JsonProperty("child_conditional_validation")
    @JsonConverter(ConditionalValidationResourceConverter)
    childConditionalValidation?: ConditionalValidationResource;

    @JsonProperty("parent_is_mandatory")
    parentIsMandatory: boolean;

    @JsonProperty("parent_conditional_validation")
    @JsonConverter(ConditionalValidationResourceConverter)
    parentConditionalValidation?: ConditionalValidationResource;

    @JsonProperty("inherits_security")
    inheritsSecurity: boolean;

    @JsonProperty("allow_navigation")
    allowNavigation: boolean = true;

    @JsonProperty("is_nested")
    isNested: boolean;

    @JsonProperty("nested_properties")
    @JsonElementType(String)
    nestedProperties: Array<string> = [];

    @JsonProperty("nested_permissions")
    nestedPermissions: boolean;

    @JsonProperty("is_taxonomy_relation")
    isTaxonomyRelation: boolean;

    @JsonProperty("is_taxonomy_hierarchy_relation")
    isTaxonomyHierarchyRelation: boolean;

    @JsonProperty("content_is_copied")
    contentIsCopied: boolean;

    @JsonProperty("completion_is_copied")
    completionIsCopied: boolean;

    @JsonProperty("is_path_relation")
    isPathRelation: boolean;

    @JsonProperty("is_path_hierarchy_relation")
    isPathHierarchyRelation: boolean;

    @JsonProperty("path_hierarchy_score")
    pathHierarchyScore: string;

    @JsonProperty("is_rendition_relation")
    isRenditionRelation: boolean;

    @JsonProperty("associated_labels")
    associatedLabels: MapCultureTo<string> = {};

    @JsonProperty("associated_entitydefinition")
    associatedEntityDefinition: Link;

    get definitionType(): MemberDefinitionType {
        return MemberDefinitionType.Relation;
    }

    constructor(init?: Partial<RelationDefinitionResource>) {
        super(DataType.Relation);
        Object.assign(this, init);
    }
}
